<template>
  <el-dialog  title="选择报警设备" :modal="false" :visible.sync="showBlock" :show-close="true"  width="800px" :before-close="closedBtn"  :close-on-click-modal="false">
    <div>
      12324123
    </div>
  </el-dialog>
</template>

<script>
export default {

}
</script>

<style>

</style>